/* eslint-disable */
/* Автогенерация: npm start / npm run build → scripts/write-app-version.cjs */
export const CLIENT_BUILD_ID = "mpa86xas-a840d81de3277f2c";
export const CLIENT_APP_VERSION = "1.0.1";
